import React, { Component } from 'react';
// import { Button, Icon, Header, Image, Message, Container } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Box, Button, Container, Grid, TextField, Typography, Alert, AlertTitle } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

var getParams = function (url) {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};
class CheckMail extends Component {
	render() {
		var query = getParams(window.location.href);
		let newContent = `Please check your mailbox of ${query.mail}`;
		return (
			// <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
			// 	<Container style={{ width: '500px' }}>
			// 		<Button as={Link} to="/login" color="teal" compact>
			// 			<Icon name="arrow left" />
			// 			Go to Login Page
			// 		</Button>
			// 		<Header as="h2" textAlign="center">
			// 			<Image src="/maytapi.svg" style={{ width: '6rem', margin: '10px' }} />
			// 			<div style={{ fontSize: '18px' }}>
			// 				<p style={{ margin: 0 }}>Maytapi</p>
			// 			</div>
			// 		</Header>
			// 		<Message
			// 			icon="mail"
			// 			success
			// 			header="Password reset link has been successfully sending."
			// 			content={'Please check your mailbox of ' + query.mail}
			// 		/>
			// 	</Container>
			// </div>
			<Box
				component="main"
				sx={{
					alignItems: 'center',
					display: 'flex',
					flexGrow: 1,
					minHeight: '100%',
				}}
			>
				<Container maxWidth="sm">
					<Box sx={{ my: 3 }} style={{ textAlign: 'center' }}>
						<img
							src="/maytapi_full.svg"
							style={{
								width: '6rem',
								background: '#009687',
								padding: '12px',
								borderRadius: '3px',
								margin: '10px',
							}}
						/>
					</Box>
					<Box sx={{ my: 3 }} style={{ textAlign: 'center' }}>
						<Typography color="textPrimary" variant="h4">
							MAYTAPI
						</Typography>
					</Box>
					<Alert severity="success">
						Password reset link has been successfully sending.
						<br />
						<strong>{newContent}</strong>
					</Alert>
					<Grid container spacing={3} sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
						<Grid item xs={12} md={6}>
							<Button
								sx={{
									':hover': {
										color: '#fafafa',
										backgroundColor: '#2185d0 !important',
									},
								}}
								fullWidth
								style={{ background: '#2185d0' }}
								href="/api/auth/google"
								size="large"
								variant="contained"
							>
								Go to Login Page
							</Button>
						</Grid>
					</Grid>
				</Container>
			</Box>
		);
	}
}
export default CheckMail;
